import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import PageLoader from '../loaders/pageLoader';

const CookieNotice = lazy(() => import('../../components/pages/cookies/cookieNotice'));
const ErrorPage = lazy(() => import('../../components/pages/errorPage'));

const IS_AMEX_PROVIDER = globalThis.IS_PLAYWRIGHT_RUNNING
	? globalThis.PLAYWRIGHT_CARD_PROVIDER === 'AMEX'
	: globalThis.cardProvider.IS_AMEX_PROVIDER_SETUP;

export const cookieNoticePath = '/cookie-notice' as const;

export const cookieRoutes = {
	path: cookieNoticePath,
	element: <Outlet />,
	children: [
		{
			index: true,
			element: <Suspense fallback={<PageLoader />}>{IS_AMEX_PROVIDER ? <ErrorPage /> : <CookieNotice />}</Suspense>,
		},
	],
};
